import {
	CheckBox,
	Col,
	FormHelperText,
	RadioButton,
	Row,
	Stack,
	TagInputNoNew,
} from 'components/ui';
import remove from 'lodash/remove';
import uniqBy from 'lodash/uniqBy';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { LexiconButton } from 'VaxForm_08_Impfschaeden/components/LexikonButton.js';

const Vorerkrankungen = ({ update, validation, formData, anotherPerson }) => {
	const [t] = useTranslation();
	const [search, setSearch] = useState('');
	const globHealthDamages = useSelector(
		(state) => state.masterData.globHealthDamages
	);
	const health_damage_options = globHealthDamages
		?.map((item) => {
			let newItem = { ...item };
			if (item.lang_iso_code == 'translation') {
				newItem.name = t(
					'master_data.health_damage.' + item.health_damage_i18n_key
				);
			} else {
				newItem.name = newItem.health_damage_i18n_key;
			}
			return newItem;
		})
		.filter((item) => item.is_selectable == true && item.is_pre_illness == true)
		.sort((a, b) => a.name.localeCompare(b.name));

	const tag_options = (() => {
		if (search.length == 0) return health_damage_options;
		else
			return health_damage_options.concat({
				name:
					t('impfschaeden.erfassen.hinzufuegen_text', 'Hinzufügen: ') + search,
			});
	})();

	return (
		<>
			<Row xs={12} style={{ marginTop: '20px' }}>
				<Col xs={12}>
					<Stack direction='horizontal' gap={3} spacing={2}>
						<RadioButton
							name='healthy'
							value='yes'
							label={t('common.ja')}
							checked={formData?.healthy_before_vax === 'yes'}
							onChange={(e) =>
								update({
									healthy_before_vax: e.target.value,
									vax_pre_health_damage_tags: [],
								})
							}
							isInvalid={validation['healthy_before_vax']}
						/>
						<RadioButton
							name='healthy'
							value='no'
							label={t('common.nein')}
							checked={
								formData?.healthy_before_vax === 'no' ||
								formData?.healthy_before_vax === 'no_unknown'
							}
							onChange={(e) =>
								update({
									healthy_before_vax: e.target.value,
								})
							}
							isInvalid={validation['healthy_before_vax']}
						/>
						<RadioButton
							name='healthy'
							value='unknown'
							label={t('common.unbekannt') + ' *'}
							checked={formData?.healthy_before_vax === 'unknown'}
							onChange={(e) =>
								update({
									healthy_before_vax: e.target.value,
									vax_pre_health_damage_tags: [],
								})
							}
							isInvalid={validation['healthy_before_vax']}
						/>
					</Stack>
					{validation['healthy_before_vax'] && (
						<FormHelperText style={{ color: '#dc3545' }}>
							{t('common.pflichtfeld')}
						</FormHelperText>
					)}
				</Col>
				<Col xs={6} md={6} />
			</Row>
			<Row xs={12} style={{ marginTop: '20px' }}>
				<Col xs={12} className='d-flex flex-row'>
					{(formData?.healthy_before_vax === 'no' ||
						formData?.healthy_before_vax === 'no_unknown') && (
						<>
							<div className='flex-grow-1'>
								<TagInputNoNew
									disabled={formData?.healthy_before_vax === 'no_unknown'}
									options={tag_options}
									value={formData?.vax_pre_health_damage_tags || []}
									onInputChange={(event, value) => {
										setSearch(value);
									}}
									onChange={(e, newValues) => {
										newValues = newValues.map((item) => {
											let newItem;
											if (typeof item == 'string') {
												newItem = { name: item };
											} else {
												newItem = { ...item };
											}
											newItem.name = newItem.name.replace(
												t(
													'impfschaeden.erfassen.hinzufuegen_text',
													'Hinzufügen: '
												),
												''
											);
											return newItem;
										});
										update({
											vax_pre_health_damage_tags: uniqBy(newValues, 'name'),
										});
									}}
									label={
										t('impfschaeden.erfassen.vorerkrankungen_eingeben') + ' *'
									}
									isInvalid={validation['vax_pre_health_damage_tags']}
								/>
								<FormHelperText>
									{t('impfschaeden.erfassen.hinweis_schlagworte')}
								</FormHelperText>
							</div>
							{/* <div className='ms-3'>
								<a
									href={API_URL + 'v1/vax/get_lexicon'}
									// target='_blank'
									rel='noreferrer'
								>
									<Button className='p-2'>
										<MenuBook />
									</Button>
								</a>
							</div> */}
							{/* <div className='ms-3'>
								<a
									href={'/impfschaden/schlagworte/lexicon'}
									target='_blank'
									rel='noreferrer'
								>
									<Button className='p-2' style={{ color: 'white' }}>
										<MenuBook />
									</Button>
								</a>
							</div> */}
							<div className='ms-1'>
								<LexiconButton
									label={
										t('impfschaeden.erfassen.vorerkrankungen_eingeben') + ' *'
									}
									tag_options={tag_options}
									validation={validation}
									setSearch={setSearch}
									update={update}
									countProperty={'vax_pre_health_damage_tags'}
									formData={formData}
									onSelect={(newTag) => {
										let newValues = formData
											? [...formData.vax_pre_health_damage_tags]
											: [];
										if (
											newValues.find(
												(item) =>
													item.glob_health_damage_id ==
													newTag.glob_health_damage_id
											)
										) {
											remove(newValues, (item) => {
												return (
													item.glob_health_damage_id ==
													newTag.glob_health_damage_id
												);
											});
										} else {
											newValues = [...newValues, newTag];
										}

										update({
											vax_pre_health_damage_tags: uniqBy(newValues, 'name'),
										});
									}}
									selected={formData?.vax_pre_health_damage_tags.map((item) => {
										return item.glob_health_damage_id;
									})}
								/>
							</div>
						</>
					)}
				</Col>
				<Col xs={12} md={6} />
			</Row>
			{anotherPerson &&
				(formData?.healthy_before_vax === 'no' ||
					formData?.healthy_before_vax === 'no_unknown') && (
					<Row className='mt-3'>
						<Col>
							<div>
								<CheckBox
									label={t('common.keine_angaben_vorerkrankung')}
									onChange={() =>
										update({
											healthy_before_vax:
												formData?.healthy_before_vax === 'no'
													? 'no_unknown'
													: 'no',
											vax_pre_health_damage_tags: [],
										})
									}
									checked={formData?.healthy_before_vax === 'no_unknown'}
									disabled={false}
								/>
							</div>
						</Col>
					</Row>
				)}
		</>
	);
};

Vorerkrankungen.propTypes = {
	update: PropTypes.func,
	formData: PropTypes.object,
	validation: PropTypes.object,
	anotherPerson: PropTypes.bool,
};

export { Vorerkrankungen };
